export default "__VITE_ASSET__CQenBE1R__"